

module.exports = __webpack_require__.stylable.create(
    "AddressInput768403399",
    {"classes":{"root":"AddressInput768403399__root","option":"AddressInput768403399__option","iconWrapper":"AddressInput768403399__iconWrapper","icon":"AddressInput768403399__icon","optionContent":"AddressInput768403399__optionContent"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    5,
    "AddressInput768403399",
    null
);
